import React from 'react';
const pillars = [{
  letter: 'B',
  title: 'Biociclos de Sueño',
  description: 'Sincronización hormonal para consolidar 7-10 horas de sueño profundo'
}, {
  letter: 'E',
  title: 'Estimulación Sináptica',
  description: 'Micro-acciones de 5 min para disparar el IQ y la conexión cognitiva'
}, {
  letter: 'B',
  title: 'Bio-Nutrición Evolutiva',
  description: 'El mapa de combustible para construir el cerebro de élite'
}, {
  letter: 'E',
  title: 'Estructura de Autonomía',
  description: 'El protocolo para que tu bebé aprenda a autorregularse'
}];
export function SolutionSection() {
  return <section className="bg-gradient-to-br from-[#3D2B1F] to-[#6B4C3B] text-[#FAF7F2] py-16 px-5" data-id="element-240">
      <div className="max-w-[900px] mx-auto" data-id="element-241">
        <div className="text-center mb-2.5" data-id="element-242">
          <span className="inline-block bg-white/10 text-[#C9A96E] text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full font-sans font-bold" data-id="element-243">
            La solución
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl text-[#FAF7F2] mb-4 leading-tight text-center" data-id="element-244">
          El Protocolo B.E.B.E. 365
        </h2>

        <p className="text-lg text-[rgba(250,247,242,0.7)] text-center max-w-[650px] mx-auto mb-12 italic" data-id="element-245">
          4 pilares de ingeniería biológica para el primer año de vida
        </p>

        <div className="grid md:grid-cols-4 gap-6" data-id="element-246">
          {pillars.map((pillar, idx) => <div key={idx} className="bg-white/5 rounded-2xl p-6 text-center border border-white/10 transition-all hover:bg-[rgba(183,110,121,0.2)] hover:-translate-y-1" data-id="element-247">
              <div className="text-5xl font-bold text-[#B76E79] leading-none mb-2.5" data-id="element-248">
                {pillar.letter}
              </div>
              <h3 className="text-base text-[#FAF7F2] mb-2" data-id="element-249">{pillar.title}</h3>
              <p className="text-sm text-[rgba(250,247,242,0.7)] font-sans" data-id="element-250">
                {pillar.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}